import type { SectionMeta } from '../types/profile'

export const sections: SectionMeta[] = [
  {
    index: '01',
    path: '/about',
    navLabel: 'About',
    title: 'About Janice Munday',
    overline: 'Section 01 — About',
    summary: 'Personal profile, governance philosophy and board availability.',
  },
  {
    index: '02',
    path: '/experiences',
    navLabel: 'Experiences',
    title: 'Current & Recent Board Appointments',
    overline: 'Section 02 — Experiences',
    summary: 'Chair and Non-Executive Director mandates, in full.',
  },
  {
    index: '03',
    path: '/skills',
    navLabel: 'Skills',
    title: 'Boardroom Skills & Leadership Craft',
    overline: 'Section 03 — Skills',
    summary: 'Chairing, negotiation, stewardship and people leadership.',
  },
  {
    index: '04',
    path: '/',
    navLabel: 'Executive Hero & Board Positioning',
    title: 'Executive Hero & Board Positioning',
    overline: 'Section 04 — Positioning',
    summary: 'Portrait, headline and the board seat she is positioned for.',
  },
  {
    index: '05',
    path: '/impact',
    navLabel: 'Executive Impact & Capital Metrics Grid',
    title: 'Executive Impact & Capital Metrics',
    overline: 'Section 05 — Impact Metrics',
    summary: 'Quantified value, capital and scale delivered.',
  },
  {
    index: '06',
    path: '/value-proposition',
    navLabel: 'Strategic Value Proposition & Board Competencies',
    title: 'Strategic Value Proposition & Board Competencies',
    overline: 'Section 06 — Value Proposition',
    summary: 'The case for appointment and the six core competencies.',
  },
  {
    index: '07',
    path: '/career',
    navLabel: 'Executive Career Track Record',
    title: 'Executive Career Track Record',
    overline: 'Section 07 — Career Track Record',
    summary: 'Executive line roles across UK Government, in sequence.',
  },
  {
    index: '08',
    path: '/technical',
    navLabel: 'Technical Mastery & Systems Portfolio',
    title: 'Technical Mastery & Systems Portfolio',
    overline: 'Section 08 — Technical Mastery',
    summary: 'Industrial technologies and governance systems commanded.',
  },
  {
    index: '09',
    path: '/governance-education',
    navLabel: 'Board Experience, Education & Civic Leadership',
    title: 'Board Experience, Education & Civic Leadership',
    overline: 'Section 09 — Committees, Education & Civic',
    summary: 'Committee craft, qualifications and honorary appointments.',
  },
  {
    index: '10',
    path: '/contact',
    navLabel: 'Board Inquiry & Direct Contact Portal',
    title: 'Board Inquiry & Direct Contact Portal',
    overline: 'Section 10 — Contact',
    summary: 'Direct enquiry routes for appointments and advisory work.',
  },
]
